import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router'
import { DeviceNameHOC } from '../../hocs'
import { TYPE_NAMES } from '../../containers/ESSearch/constants'
import { NAV_MODULE_ICON } from '../../constants'
import { SVGIcon } from '..'
import { getVersionIcon, sanitizeHTML } from '../../helpers/utils'

const ResultContainer = styled.div`
  svg {
    height: 25px;
    width: 25px;
    fill: var(--clr-grey-3-to-white);
    margin: 5px 10px;
    display: inline-block;
    vertical-align: middle;
  }
`
const Title = styled.div`
  font-size: 17px;
  margin-bottom: 5px;
  font-weight: 600;
  color: var(--clr-accent);
`
const Description = styled.div`
  font-size: 14px;
  color: var(--clr-grey-3-to-white);
`
const DeviceName = styled.div`
  font-size: 14px;
  margin-bottom: 5px;
  color: var(--clr-black-to-text);
`

const Result = ({ item, deviceName, trackClick, language, version }) => {
  const titleContent = (
    <span>
      <Link to={item.url} onClick={trackClick.bind(this, item.url)}>
        <span dangerouslySetInnerHTML={{ __html: sanitizeHTML(item.title) }} />
      </Link>
      {NAV_MODULE_ICON[item.type] && (
        <SVGIcon
          title={TYPE_NAMES[language][item.type]}
          src={getVersionIcon(NAV_MODULE_ICON[item.type], version)}
        />
      )}
    </span>
  )

  return (
    <ResultContainer className='results-container'>
      <Title>{titleContent}</Title>
      <DeviceName className="device-name">
        {deviceName(item, true)}
      </DeviceName>
      <Description>
        <div
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(item.description) }}
        />
      </Description>
      <hr />
    </ResultContainer>
  )
}

Result.propTypes = {
  item: PropTypes.shape({
    url: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    phonefk: PropTypes.number.isRequired
  }).isRequired,
  deviceName: PropTypes.func.isRequired,
  trackClick: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  version: PropTypes.string
}
export default DeviceNameHOC(Result)



// WEBPACK FOOTER //
// ./src/components/ESSearch/Result.js